<template>
  <transition :name="isMobile ? 'slide-bottom' : 'slide-right'">
    <div
      v-if="show"
      class="map-property-info"
    >
      <div
        class="map-notch"
        @touchstart="startDrag($event, 'touch')"
        @touchmove="handleDrag($event, 'touch')"
        @touchend="stopDrag"
        @mousedown="startDrag($event, 'mouse')"
        @mousemove="handleDrag($event, 'mouse')"
        @mouseup="stopDrag"
      >
        <svg
          width="64"
          height="5"
          viewBox="0 0 64 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="64"
            height="5"
            rx="2.5"
            fill="#D1D1D1"
          />
        </svg>
      </div>
      <div class="map-content">
        <template v-if="mapType === 'default-map'">
          <div
            v-if="location.Image"
            class="media"
          >
            <picture
              :key="location.Id"
              v-lazyload="{
                src: location.Image,
                set: [{ width: '810', height: '476' }],
                fit: 'crop',
                align: 'center',
              }"
              class="image-wrapper"
            >
              <img
                class="image"
                src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
              >
            </picture>
          </div>
          <div class="map-content-body">
            <div class="title">
              {{ location.Title }}
            </div>
            <div class="description">
              <p>
                {{ location.Description }}
              </p>
            </div>
            <div
              v-if="hasContactInfo"
              class="contact-info"
            >
              <ul>
                <li v-if="location.Email">
                  <span class="icon-envelope icon" />
                  <a :href="`mailto:${location.Email}`">
                    {{ location.Email }}
                  </a>
                </li>
                <li v-if="location.Phone">
                  <span class="icon-phone icon" />
                  <a :href="`tel:${location.Phone}`">
                    {{ location.Phone }}
                  </a>
                </li>
                <li v-if="location.Address">
                  <span class="icon-pin icon" />
                  <span>{{ location.Address }}</span>
                </li>
              </ul>
            </div>
            <div class="map-cta">
              <a
                v-if="mapType === 'default-map'"
                :href="location.Link"
                :target="location.LinkTarget"
                @click="openItemPage"
              >{{ ctaButtonTitle }}</a>
            </div>
          </div>
        </template>
      </div>
      <div
        v-if="mapType === 'property-map'"
        class="map-cta-property-map"
      >
        <a
          :href="location.Link"
          target="_blank"
        >Get Directions</a>
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * Component that displays detailed information about a selected map location.
 *
 * Features:
 * - Responsive design with mobile-friendly animations
 * - Touch/drag interactions for dismissal
 * - Displays location image, title, description
 * - Shows contact information when available
 * - Handles external links with confirmation modal
 * - Different layouts for property and default map types
 *
 * Props:
 * - show: Boolean to control visibility
 * - location: Object containing location details
 * - mapType: String indicating map type ('default-map' or 'property-map')
 * - ctaButtonTitle: String for call-to-action button
 * - isMobile: Boolean for responsive behavior
 *
 * Events:
 * - start-drag: Touch/mouse drag start
 * - handle-drag: Touch/mouse drag movement
 * - stop-drag: Touch/mouse drag end
 * - open-item-page: CTA button click
 */
  export default {
    name: 'MapInfoOverlay',

    props: {
      show: {
        type: Boolean,
        required: true
      },
      location: {
        type: Object,
        required: true
      },
      mapType: {
        type: String,
        required: true
      },
      ctaButtonTitle: {
        type: String,
        required: true
      },
      isMobile: {
        type: Boolean,
        required: true
      }
    },

    data: () => ({
      dragging: false,
      startY: 0,
    }),

    computed: {
      hasContactInfo() {
        return (
          !!this.location.Address
          || !!this.location.Email
          || !!this.location.Phone
        )
      }
    },

    methods: {
      startDrag(event, type) {
        this.dragging = true
        this.startY = type === 'touch' ? event.touches[0].clientY : event.clientY
      },

      handleDrag(event, type) {
        if (this.dragging) {
          const deltaY = (type === 'touch' ? event.touches[0].clientY : event.clientY)
            - this.startY
          if (deltaY > 0) {
            if (this.showMarkerOverlay) {
              this.closeMapContent()
              this.stopDrag()
            }
          }
        }
      },

      stopDrag() {
        this.dragging = false
        this.startY = 0
      },

      openItemPage(e) {
        if (this.selectedLocation.LinkTarget.startsWith('external:')) {
          this.$root.$refs.externalLinkModal.onClick(e)
        }
      }
    }
  }
</script>
